import { Flex, Input, Spin, Table } from "antd";
import { useGetInventoryQuery } from "../../../api/inventory/inventoryApi";
import inventoryTableColumns from "./InventoryTableColumns";
import { useEffect, useMemo, useState } from "react";
import useQuery from "../../../utils/useQuery";
import { InventoryItem } from "../../../api/inventory/InventoryItem";
import ItemDetailModal from "./ItemDetailModal";

export default function ManageInventoryPage() {
  const { data, error, isFetching } = useGetInventoryQuery();
  const query = useQuery();
  const [isLoadedQuery, setIsLoadedQuery] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [detailItem, setDetailItem] = useState<InventoryItem | null>(null);

  useEffect(() => {
    const search = query.get("search")
    if (isLoadedQuery || !search) {
      return;
    }
    setSearchQuery(search);
    setIsLoadedQuery(true);
  }, [query, isLoadedQuery]);

  useEffect(() => {
    const iccid = query.get("iccid");
    if (isLoadedQuery || !iccid) {
      return;
    }
    const item = data?.find(x => x.Iccid === iccid);
    if (item) {
      setDetailItem(item);
      setIsLoadedQuery(true);
    }
  }, [query, isLoadedQuery, data]);

  const processedData = useMemo(() => {
    if (!data) {
      return [];
    }

    const filtered = data.filter(x => {
      if (searchQuery.length === 0) {
        return true;
      }
      const json = JSON.stringify(x);
      if (json.toLowerCase().includes(searchQuery.toLowerCase())) {
        return true;
      }
      return false
    });

    let sorted = filtered.toSorted((a, b) => a.VendorSku.localeCompare(b.VendorSku));

    return sorted
  }, [data, searchQuery]);

  const filteredData = data?.filter(x => {
    if (searchQuery.length === 0) {
      return true;
    }
    const json = JSON.stringify(x);
    if (json.includes(searchQuery)) {
      return true;
    }
    return false
  }) ?? [];

  console.log(data, error, isFetching);
  return (
    <Flex gap={8} vertical>
    <ItemDetailModal
      item={detailItem}
      onClose={() => setDetailItem(null)}
    />
    <Input.Search
      value={searchQuery}
      onChange={e => setSearchQuery(e.target.value)}
      placeholder="Search all fields"
    />
    <Table
      columns={inventoryTableColumns}
      dataSource={processedData}
      loading={{
        indicator: (
          <div>
            <Spin />
          </div>
        ),
        spinning: isFetching,
      }}
      pagination={{
        defaultPageSize: 20,
        pageSizeOptions: [10, 20, 50, 100],
        defaultCurrent: 1
      }}
      size="small"
      bordered
      showHeader
    />
    </Flex>
  );
}